const GOOGLE_ANALYTICS_KEY = "G-FYEXEQY3QC";

export { GOOGLE_ANALYTICS_KEY };
